import { render, staticRenderFns } from "./CamtPotentialMatchesComponent.vue?vue&type=template&id=5c5f280f&"
import script from "./CamtPotentialMatchesComponent.vue?vue&type=script&lang=js&"
export * from "./CamtPotentialMatchesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports